import React, { useState } from 'react'
import styled from 'styled-components'

import ImageUploading, { ImageListType } from 'react-images-uploading'

type ImagePickerProps = {
    placeholderImage: string
    onPictureSelected: (picture: File | null) => void
    className?: string
}

const ImagePicker: React.FunctionComponent<ImagePickerProps> = ({ onPictureSelected, placeholderImage, className }) => {
    const [pictures, setPictures] = useState<ImageListType>([])
    
    const setUploadedImage = (imageList: ImageListType, addUpdateIndex?: number[]) => {
        console.log(imageList, addUpdateIndex)
        setPictures(imageList)

        if (imageList.length > 0) {
            onPictureSelected(imageList[0].file || null)
        }
    }

    return (
        <ImageUploading
            value={pictures}
            onChange={setUploadedImage}
            maxNumber={1}
            dataURLKey="dataURL"
        >
            {({
                imageList,
                onImageUpload,
                onImageRemoveAll,
                }) => (
                    <Container
                        onClick={onImageUpload}
                        className={className}
                    >
                        <ImagePreview src={imageList.length > 0 ? imageList[0].dataURL! : placeholderImage}/>
                        {imageList.length > 0 && <RemoveImage 
                            src={require('./images/close.jpg')} 
                            onClick={(ev) => { 
                                ev.stopPropagation()
                                onImageRemoveAll()
                            }} 
                        />}
                    </Container>
                )
            }
        </ImageUploading>
    )
}


const Container = styled.div`
    position: relative;
    width: 100px;
    height: 100px;
    
    margin: 10px 0;

    display: flex;
    justify-content: center;

    cursor: pointer;
`

const RemoveImage = styled.div<{ src: string | null }>`
    position: absolute;
    top: -5px;
    right: -5px;

    width: 20px;
    height: 20px;
    border-radius: 50%;

    background-size: cover;
    background-position: center;
    background-color ${p => p.theme.colors.bg};
    background-image: url("${p => p.src }");
`

const ImagePreview = styled.div<{ src: string | null }>`
    height: 100%;
    width: 100%;

    border-radius: 50%;

    background-size: cover;
    background-position: center;
    background-image: url("${p => p.src }");
`


export default ImagePicker